import React from 'react';

type BackgroundProps = {
  className?: string;
  children: React.ReactNode;
};

const Background = ({className, children}: BackgroundProps) => (
  <div
    className={`bg-purple w-full h-fit flex overflow-auto ${className || ''}`}
    style={{minHeight: '100%'}}
  >
    {children}
  </div>
);

export default Background;
